var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { ServiceDesc } from './Service';
import { JsonObject, JsonProperty } from 'json2typescript';
export var Location;
(function (Location) {
    Location["Frankfurt"] = "DE-FF";
    Location["Ireland"] = "IE";
    Location["Mumbai"] = "IN-MB";
    Location["Oregon"] = "US-OR";
    Location["Singapore"] = "SG";
    Location["Sydney"] = "AU";
    Location["Virginia"] = "US-VA";
})(Location || (Location = {}));
export var DeploymentModel;
(function (DeploymentModel) {
    DeploymentModel["Global"] = "GLOBAL";
    DeploymentModel["Local"] = "LOCAL";
})(DeploymentModel || (DeploymentModel = {}));
export var AppEnvironment;
(function (AppEnvironment) {
    AppEnvironment["None"] = "";
    AppEnvironment["Development"] = "development";
    AppEnvironment["Testing"] = "testing";
    AppEnvironment["Staging"] = "staging";
    AppEnvironment["QA"] = "qa";
    AppEnvironment["Production"] = "production";
})(AppEnvironment || (AppEnvironment = {}));
var PartialApp = (function () {
    function PartialApp(partial) {
        this.id = '';
        this.clientAppId = '';
        this.name = '';
        this.product = '';
        this.location = Location.Virginia;
        this.deploymentModel = DeploymentModel.Global;
        this.domainId = '';
        this.groupId = '';
        this.lastUsed = 0;
        this.lastModified = 0;
        this.environment = AppEnvironment.None;
        this.templateId = '';
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('_id'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "id", void 0);
    __decorate([
        JsonProperty('client_app_id'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "clientAppId", void 0);
    __decorate([
        JsonProperty('name'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "name", void 0);
    __decorate([
        JsonProperty('product'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "product", void 0);
    __decorate([
        JsonProperty('location'),
        __metadata("design:type", String)
    ], PartialApp.prototype, "location", void 0);
    __decorate([
        JsonProperty('deployment_model'),
        __metadata("design:type", String)
    ], PartialApp.prototype, "deploymentModel", void 0);
    __decorate([
        JsonProperty('domain_id'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "domainId", void 0);
    __decorate([
        JsonProperty('group_id'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "groupId", void 0);
    __decorate([
        JsonProperty('last_used'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "lastUsed", void 0);
    __decorate([
        JsonProperty('last_modified'),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "lastModified", void 0);
    __decorate([
        JsonProperty('environment', String, true),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "environment", void 0);
    __decorate([
        JsonProperty('template_id', String, true),
        __metadata("design:type", Object)
    ], PartialApp.prototype, "templateId", void 0);
    PartialApp = __decorate([
        JsonObject('PartialApp'),
        __metadata("design:paramtypes", [Object])
    ], PartialApp);
    return PartialApp;
}());
export { PartialApp };
var CreateAppRequest = (function () {
    function CreateAppRequest(partial) {
        this.name = '';
        this.location = undefined;
        this.deploymentModel = undefined;
        this.environment = undefined;
        this.templateId = undefined;
        this.dataSource = undefined;
        this.createCluster = undefined;
        this.createClusterRegion = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('name'),
        __metadata("design:type", Object)
    ], CreateAppRequest.prototype, "name", void 0);
    __decorate([
        JsonProperty('location', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "location", void 0);
    __decorate([
        JsonProperty('deployment_model', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "deploymentModel", void 0);
    __decorate([
        JsonProperty('environment', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "environment", void 0);
    __decorate([
        JsonProperty('template_id', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "templateId", void 0);
    __decorate([
        JsonProperty('data_source', ServiceDesc, true),
        __metadata("design:type", ServiceDesc)
    ], CreateAppRequest.prototype, "dataSource", void 0);
    __decorate([
        JsonProperty('create_cluster', Boolean, true),
        __metadata("design:type", Boolean)
    ], CreateAppRequest.prototype, "createCluster", void 0);
    __decorate([
        JsonProperty('create_cluster_region', String, true),
        __metadata("design:type", String)
    ], CreateAppRequest.prototype, "createClusterRegion", void 0);
    CreateAppRequest = __decorate([
        JsonObject('CreateAppRequest'),
        __metadata("design:paramtypes", [Object])
    ], CreateAppRequest);
    return CreateAppRequest;
}());
export { CreateAppRequest };
var UpdateEnvironmentRequest = (function () {
    function UpdateEnvironmentRequest(partial) {
        this.environment = AppEnvironment.None;
        Object.assign(this, partial);
    }
    __decorate([
        JsonProperty('environment'),
        __metadata("design:type", Object)
    ], UpdateEnvironmentRequest.prototype, "environment", void 0);
    UpdateEnvironmentRequest = __decorate([
        JsonObject('UpdateEnvironmentRequest'),
        __metadata("design:paramtypes", [Object])
    ], UpdateEnvironmentRequest);
    return UpdateEnvironmentRequest;
}());
export { UpdateEnvironmentRequest };
//# sourceMappingURL=App.js.map